module.exports = __webpack_public_path__ + "media/img/pages/cv_icon-c2fe834a680ffe393ccae85e9ff29cf3.svg";